import { Injectable } from '@angular/core';
import {
    MatSnackBar,
    MatSnackBarRef,
    SimpleSnackBar,
} from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    private loadingRef: MatSnackBarRef<SimpleSnackBar>;

    constructor(private snackBar: MatSnackBar) {}

    show(message: string, duration: number = 4000) {
        this.snackBar.open(message, '', {
            duration,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['toast-dark', 'toast-default'],
        });
    }

    /** Alias semántico para mensajes informativos */
    info(message: string, duration: number = 4000) {
        this.show(message, duration);
    }

    success(message: string) {
        this.snackBar.open(message, '', {
            duration: 4500,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['toast-dark', 'toast-success'],
        });
    }

    error(message: string) {
        this.snackBar.open(message, '', {
            duration: 6000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['toast-dark', 'toast-error'],
        });
    }

    warn(message: string) {
        this.snackBar.open(message, '', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['toast-dark', 'toast-warning'],
        });
    }

    /** 🔵 Mostrar LOADING (no se cierra solo) */
    loading(message: string = 'Por favor espere...') {
        this.loadingRef = this.snackBar.open(`${message}`, '', {
            duration: undefined, // NO se cierra solo
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['toast-dark', 'toast-loading'],
        });
    }

    /** 🔵 Cerrar LOADING */
    closeLoading() {
        if (this.loadingRef) {
            this.loadingRef.dismiss();
            this.loadingRef = null!;
        }
    }

    /** ✅ SnackBar con botón de acción opcional */
    showWithAction(
        message: string,
        action: string = 'Cerrar',
        duration: number = 5000,
        panelClass: string[] = ['toast-dark', 'toast-default'],
        onAction?: () => void
    ) {
        const ref = this.snackBar.open(message, action, {
            duration,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass,
        });

        ref.onAction().subscribe(() => {
            if (onAction) {
                onAction();
            }
        });
    }
}
